// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file purchase_order/list_purchase_orders.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { PurchaseOrder } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.ListPurchaseOrdersRequest
 */
export class ListPurchaseOrdersRequest extends Message<ListPurchaseOrdersRequest> {
  /**
   * ID of the supplier for whom to list purchase orders
   *
   * @generated from field: string supplier_id = 1;
   */
  supplierId = "";

  /**
   * Search term to filter purchase orders by order number or supplier name
   *
   * @generated from field: string search = 2;
   */
  search = "";

  /**
   * Page number for pagination
   *
   * @generated from field: int32 page_number = 3;
   */
  pageNumber = 0;

  /**
   * Number of items per page
   *
   * @generated from field: int32 page_size = 4;
   */
  pageSize = 0;

  /**
   * Whether to include purchase orders that have been used in purchase invoices
   *
   * @generated from field: bool include_used = 5;
   */
  includeUsed = false;

  /**
   * ID of the stock point to filter purchase orders by stock point
   *
   * @generated from field: string stock_point_id = 6;
   */
  stockPointId = "";

  constructor(data?: PartialMessage<ListPurchaseOrdersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListPurchaseOrdersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "supplier_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "include_used", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "stock_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPurchaseOrdersRequest {
    return new ListPurchaseOrdersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPurchaseOrdersRequest {
    return new ListPurchaseOrdersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPurchaseOrdersRequest {
    return new ListPurchaseOrdersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListPurchaseOrdersRequest | PlainMessage<ListPurchaseOrdersRequest> | undefined, b: ListPurchaseOrdersRequest | PlainMessage<ListPurchaseOrdersRequest> | undefined): boolean {
    return proto3.util.equals(ListPurchaseOrdersRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ListPurchaseOrdersResponse
 */
export class ListPurchaseOrdersResponse extends Message<ListPurchaseOrdersResponse> {
  /**
   * List of purchase orders matching the criteria
   *
   * @generated from field: repeated com.neulink.pharmacy.PurchaseOrder purchase_orders = 1;
   */
  purchaseOrders: PurchaseOrder[] = [];

  /**
   * Total number of purchase orders matching the criteria
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<ListPurchaseOrdersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListPurchaseOrdersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "purchase_orders", kind: "message", T: PurchaseOrder, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListPurchaseOrdersResponse {
    return new ListPurchaseOrdersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListPurchaseOrdersResponse {
    return new ListPurchaseOrdersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListPurchaseOrdersResponse {
    return new ListPurchaseOrdersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListPurchaseOrdersResponse | PlainMessage<ListPurchaseOrdersResponse> | undefined, b: ListPurchaseOrdersResponse | PlainMessage<ListPurchaseOrdersResponse> | undefined): boolean {
    return proto3.util.equals(ListPurchaseOrdersResponse, a, b);
  }
}

